import styled, { css } from 'styled-components';

const primaryStyles = css`
  background: var(--blue);
  color: var(--white);
  font-weight: 600;
  border: 1px solid var(--blue);

  .loader {
    border-top: 3px solid var(--white) !important;
  }

  &:hover:not(:disabled) {
    background: var(--primary-hover);
    border-color: var(--primary-hover);
  }
`;

export const StyledButton = styled.button`
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: ${({ $gap }) => ($gap ? $gap : '8px')};
  padding: 11px 20px;
  border-radius: var(--radius);
  font-size: 14px;
  line-height: 18px;
  font-weight: 600;
  width: 100%;
  max-width: ${({ $width }) => $width && $width};
  white-space: nowrap;
  border: 1px solid transparent;
  transition: background 0.2s ease, border-color 0.2s ease, color 0.2s ease, box-shadow 0.2s ease;
  overflow: hidden;
  flex-shrink: 0;

  ${({ $variant }) =>
    (!$variant || $variant === 'primary' || $variant === 'dark') &&
    css`
      ${primaryStyles}
    `}

  ${({ $loader, disabled }) =>
    ($loader || disabled) &&
    css`
      cursor: not-allowed;
      opacity: ${disabled && !$loader ? 0.55 : 1};
    `}

  ${({ $lg }) =>
    $lg &&
    css`
      padding: 16px 24px;
      font-size: 18px;
      line-height: 22px;
      width: ${({ $width }) => ($width ? $width : '283px')};
    `}

  ${({ $variant }) =>
    $variant === 'white' &&
    css`
      background: var(--white);
      color: var(--blue);
      border-color: var(--line);
      box-shadow: 0 2px 8px rgba(0, 43, 92, 0.08);

      .loader {
        border-top: 3px solid var(--blue) !important;
      }

      &:hover:not(:disabled) {
        background: var(--line-soft);
        border-color: rgba(10, 77, 162, 0.25);
      }
    `}

  ${({ $variant }) =>
    $variant === 'primary' &&
    css`
      ${primaryStyles}
    `}

  ${({ $variant }) =>
    $variant === 'light' &&
    css`
      background: var(--line-soft);
      color: var(--ink);
      border-color: var(--line);

      &:hover:not(:disabled) {
        background: var(--cream);
        border-color: rgba(10, 77, 162, 0.2);
        color: var(--blue);
      }
    `}

  ${({ $variant }) =>
    $variant === 'secondary' &&
    css`
      background: var(--line-soft);
      color: var(--ink);
      border-color: var(--line);

      &:hover:not(:disabled) {
        background: var(--cream);
        border-color: rgba(10, 77, 162, 0.2);
        color: var(--blue);
      }
    `}

  ${({ $variant }) =>
    $variant === 'secondary-outline' &&
    css`
      background: var(--white);
      color: var(--ink);
      border-color: var(--line);

      .loader {
        border-top: 3px solid var(--blue) !important;
      }

      &:hover:not(:disabled) {
        background: var(--line-soft);
        border-color: rgba(10, 77, 162, 0.25);
        color: var(--blue);
      }
    `}

  ${({ $variant }) =>
    $variant === 'cross' &&
    css`
      background: transparent;
      color: var(--ink);
      border: none;
      padding: 0;
      width: auto;
      min-width: 0;
    `}

  ${({ $variant }) =>
    $variant === 'outline' &&
    css`
      background: var(--white);
      color: var(--blue);
      border-color: rgba(10, 77, 162, 0.35);

      .loader {
        border-top: 3px solid var(--blue) !important;
      }

      &:hover:not(:disabled) {
        background: var(--line-soft);
        border-color: var(--blue);
      }
    `}

  ${({ $variant }) =>
    $variant === 'danger' &&
    css`
      background: var(--bad);
      color: var(--white);
      border-color: var(--bad);

      .loader {
        border-top: 3px solid var(--white) !important;
      }

      &:hover:not(:disabled) {
        filter: brightness(0.95);
      }
    `}

  ${({ $variant }) =>
    $variant === 'dark' &&
    css`
      ${primaryStyles}
    `}

  ${({ $outline }) =>
    $outline &&
    css`
      background: var(--white);
      border-color: var(--line);
      color: var(--ink);

      &:hover:not(:disabled) {
        border-color: var(--blue);
        color: var(--blue);
      }
    `}

  .loader {
    width: 17px;
    height: 17px;
    border-radius: 50%;
    display: inline-block;
    border-top: 3px solid var(--white);
    border-right: 3px solid transparent;
    box-sizing: border-box;
    animation: rotation 1s linear infinite;

    ${({ $lg }) =>
      $lg &&
      css`
        width: 27px;
        height: 27px;
      `}
  }

  @keyframes rotation {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }

  &:disabled {
    cursor: not-allowed;
  }
`;
